<app-dialog-header [title]="title"></app-dialog-header>
<mat-dialog-content>
  <div class="body-2 break-word" [innerHTML]="description"></div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="confirmDialogButtons"></app-dialog-footer>
<ng-template #confirmDialogButtons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button *ngIf="!buttonCancelHidden" mat-button mat-dialog-close>{{buttonCancel}}</button>
      <button mat-stroked-button color="primary" *ngFor="let action of additionalActions" (click)="close(action.result)">{{action.title}}</button>
      <button *ngIf="!buttonOkHidden" mat-flat-button color="primary" (click)="close()">{{buttonOk}}</button>
    </div>
  </div>
</ng-template>
